import styled from 'styled-components';

export const StyledRefundAmount = styled.span`
  display: inline;
  font-weight: bold;
  margin: 0 0 0 0.5rem;

  &::before {
    content: '(';
  }

  &::after {
    content: ')';
  }
`;
